import styled from 'styled-components';
import { device, Common } from '@stockbit/ui';

const { Flex, Text } = Common;

export const Header = styled(Flex).attrs({ align: 'center' })`
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100vh;

  @media ${device.laptop} {
    flex-direction: row;
    justify-content: space-between;
  }

  img {
    max-width: 100%;
  }
`;

export const HeaderTitle = styled(Text).attrs({
  as: 'h1',
  family: 'bold',
})`
  margin-top: 120px;
  font-size: 48px;
  text-align: center;

  @media ${device.laptop} {
    font-size: 60px;
    text-align: left;
  }
`;

export const HeaderDescription = styled.div`
  @media ${device.laptop} {
    width: 60%;
    padding-right: 50px;
  }
`;

export const HeaderSubtitle = styled(Text)`
  font-size: 18px;
  margin: 30px 0;
  padding-top: 15px;
  text-align: center;

  @media ${device.laptop} {
    font-size: 22px;
    margin: 0 0 9vh 0;
    text-align: left;
  }
`;
